import React from "react";
import styled from "styled-components";
import Avatar from "../../../../assets/pages/landing/AI.svg";
import { ArrowRight } from "lucide-react";

const AICTA = () => {
  const handleChatNow = () => {
    window.dispatchEvent(new Event("open-global-chatbot"));
  };

  return (
    <Wrapper>
      <Title>NMDFC is now AI Empowered!</Title>
      <About>
        Now you can ask your very own NMDFC AI Bot for any required
        assistance.
      </About>
      <ChatButton
        type="button"
        onClick={handleChatNow}
        aria-label="Chat Now - Open NMDFC Virtual Assistant"
      >
        <span>Chat Now</span>
        <ArrowRight aria-hidden="true" />
      </ChatButton>
      <AssistantImage src={Avatar} alt="" aria-hidden="true" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  box-sizing: border-box;
  min-height: 220px;
  background: #fac03b;
  border: 1px solid #c78b01;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 35px 40px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  position: relative;
  overflow: hidden;

  @media (max-width: 520px) {
    min-height: 310px;
    padding: 22px;
  }
`;

const Title = styled.h2`
  font-weight: 700;
  font-size: 27px;
  line-height: 30px;
  color: #493820;
  max-width: calc(100% - 210px);

  @media (max-width: 520px) {
    max-width: 62%;
    font-size: 23px;
    line-height: 1.2;
  }

  @media (max-width: 380px) {
    font-size: 21px;
  }
`;

const About = styled.p`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #493820;
  max-width: min(420px, calc(100% - 210px));

  @media (max-width: 520px) {
    max-width: 64%;
    font-size: 16px;
    line-height: 1.4;
  }

  @media (max-width: 380px) {
    max-width: 58%;
    font-size: 15px;
  }
`;

const ChatButton = styled.button`
  width: fit-content;
  max-width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 0.75rem;
  border-radius: 999px;
  background: #493820;
  padding: 12px 26px;
  color: #ffffff;
  position: relative;
  z-index: 2;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;

  &:hover {
    opacity: 0.92;
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 3px solid #493820;
    outline-offset: 3px;
  }
`;

const AssistantImage = styled.img`
  position: absolute;
  top: -34px;
  right: -20px;
  height: 280px;
  width: auto;
  max-width: none;

  @media (max-width: 520px) {
    top: auto;
    right: -8px;
    bottom: -10px;
    height: clamp(165px, 46vw, 190px);
  }
`;

export default AICTA;
